import React from "react";

const handleGooglePay = (props) => {
  const options = [
    {
      text: 'Qu’est-ce qu’INTERAC avec Google Pay?',
      handler: props.actionProvider.handleGooglePay1,
      id: 1,
    },
    {
      text: 'Qu’est-ce que Google Pay, et puis-je l’utiliser en tant qu’utilisateur de Débit INTERAC?',
      handler: props.actionProvider.handleGooglePay2,
      id: 2
    },
    {
      text: 'Quelles cartes et quels appareils peuvent être utilisés avec Google Pay?',
      handler: props.actionProvider.handleGooglePay3,
      id: 3
    },
    {
      text: 'Comment puis-je obtenir Google Pay sur mon appareil?',
      handler: props.actionProvider.handleGooglePay4,
      id: 4
    },
    {
      text: 'Lorsque je tente d’ajouter ma carte de débit à Google Pay, pourquoi est-ce que je reçois le message suivant : « Cette carte ne peut pas encore être ajoutée. Votre carte sera bientôt prise en charge. Nous vous aviserons lorsque vous pourrez ajouter votre carte. »??',
      handler: props.actionProvider.handleGooglePay5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleGooglePay;